"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Road.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Road = function Road(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 167.54 194.16"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Road Icon"), _react2.default.createElement("path", {
    d: "M92.16-.02l-7.1.87c3.17 26-19.31 65.23-60.12 105.05-33.56 32.75-23.69 86-23.25 88.24l7-1.36c-.1-.52-9.54-51.74 21.23-81.77C91.04 51.41 93.8 13.52 92.16-.02zm75.07 0l-7.1.87c3.17 26-19.31 65.23-60.12 105.05-33.57 32.75-23.69 86-23.26 88.24l7-1.36c-.1-.52-9.54-51.74 21.23-81.77 61.14-59.6 63.9-97.49 62.25-111.03zM44.46 172.16l-7.18-.09a119 119 0 0 0 1.61 22.08l7-1.36a114 114 0 0 1-1.43-20.63zm17.72-66.25a77.79 77.79 0 0 0-19 30.46l6.75 2.36a70.7 70.7 0 0 1 17.24-27.75l.45-.44-5-5.11zm29.57-21.43a246.44 246.44 0 0 0 20.9-28.92l-6.11-3.72a239.1 239.1 0 0 1-20.26 28.08zm35.7-61.9a60.54 60.54 0 0 0 1.94-22.6l-7.1.87a53.44 53.44 0 0 1-1.76 19.91z",
    className: "road",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }));
};
exports.default = Road;